module.exports = __webpack_public_path__ + "static/media/J1_REFL.bb7abdef.png";